'use strict';

angular.module('licensure.services')
    .factory('Logger', ['$http', '$q', function ($http, $q) {
        return {
            logAccess: function (user_id, field) {
                var d = $q.defer();

                $http({
                    method: 'POST',
                    url: apiLocation + '/api/Logger/LogAccess',
                    data: {
                        user_id: user_id,
                        field: field
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            logFormProgress: function (text, fb_response_id) {
                var d = $q.defer();

                $http({
                    method: 'POST',
                    url: apiLocation + '/api/Logger/LogFormProgress',
                    data: {
                        text: text,
                        fb_response_id: fb_response_id
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            logAngularApiErrors: function (data, status, config) {
                var d = $q.defer();

                if (!data || !config) {
                    d.resolve(null);
                }
                else {
                    var message = 'Message: ' + data.message + ' Method: ' + config.method + ' URL: ' + config.url + ' Status: ' + status;

                    $http({
                        method: 'POST',
                        url: apiLocation + '/api/Logger/LogAngularApiErrors',
                        data: {
                            errorText: message
                        }
                    }).
                        then(function (data, status, headers, config) {
                            d.resolve(data);
                        }).
                        catch(function (data, status, headers, config) {

                        })

                    return d.promise;
                }
            }
        }
    }])
;